import { createAsyncThunk } from '@reduxjs/toolkit';
import labApi from '../../core/api/lab.api';
import { ShipmentConfirmQCResponse } from '../../core/api/lab.types';

export const shipmentConfirmQCThunk = createAsyncThunk('shipment/confirmQC', async (_, { rejectWithValue }: any) => {
  const response: ShipmentConfirmQCResponse = await labApi.shipmentConfirmQC();
  if (response.data?.confirmShipmentQCPass) {
    return response.data?.confirmShipmentQCPass;
  }
  return rejectWithValue(response.errors);
});
